import SearchForm from './search-form';
import SearchResults from './search-results';
import { useState, useEffect } from '@wordpress/element';

function Search( { setCartPreviewItems, setNoticeContent, setAddingToCartPreview } ) {
	const [ products, setProducts ] = useState( [] );
	const [ searchTerm, setSearchTerm ] = useState( '' );
	const isElasticSearchEnabled = !! window.QalaElasticSearch;

	useEffect( () => {
		if ( isElasticSearchEnabled ) {
			wp.hooks.addAction( 'qalaElasticCore.action.onResult.results', 'swiftCart', results => setProducts( results ) );
		}
	}, [] );

	useEffect( () => {
		if ( ! isElasticSearchEnabled && searchTerm.length > 0 ) {
			( async () => {
				try {
					const response = await fetch( '/wp-json/wp/v2/search?subtype=product&search=' + encodeURIComponent( searchTerm ) );
					const jsonBody = await response.json();

					const newProducts = jsonBody.map( product => {
						return {
							id: product.id,
							object_id: product.id,
							sku: product.id,
							title: product.title,
							priceHtml: '',
							url: '',
							image_url: '',
							quantity: 1,
							stock: -1,
							hasError: false,
							isReplaced: false,
						};
					} );

					setProducts( newProducts );
				} catch ( e ) {
					setProducts( [] );
				}
			} )();
		}
	}, [ searchTerm ] );

	useEffect( () => {
		if ( searchTerm.length === 0 ) {
			setProducts( [] );
		}
	}, [ searchTerm ] );

	return (
		<div className="qala-b2b-wholesale-swift-cart-search">
			<SearchForm searchTerm={ searchTerm } setSearchTerm={ setSearchTerm } isElasticSearch={ isElasticSearchEnabled } />
			<SearchResults products={ products } setSearchTerm={ setSearchTerm } setProducts={ setProducts } setCartPreviewItems={ setCartPreviewItems } setNoticeContent={ setNoticeContent } setAddingToCartPreview={ setAddingToCartPreview } />
		</div>
	);
}

export default Search;
